<template>
    <div class="conten">
		<div class="nTop" id="toTop" style="background-color:#FFF;">
		  <div class="wrapper clearfix">
		    <a class="logo">
		      <img src="../../assets/images/logo.jpg" alt="佰吉宏安国际能源有限公司" />
		      <h1>佰吉宏安国际能源有限公司</h1>
		    </a>
		    <a class="nt-link" @click="yanzheng('/main')">
		      <img src="../../assets/images/ico01.png" />
		      <span>个人中心</span>
		    </a>
		  </div>
		</div>
		<div class="header">
		  <div class="wrapper clearfix">
		    <div class="nav clearfix">
		      <!-- <router-link  to="/about">关于我们</router-link> -->
		      <a @click="tabIndex(1, '/home')" :class="keyIndex == 1 ? 'active' : ''">首页</a>
		      <a @click="tabIndex(2, '/about')" :class="keyIndex == 2 ? 'active' : ''">关于我们</a>
		      <a @click="tabIndex(3, '/honor')" :class="keyIndex == 3 ? 'active' : ''">资质荣誉</a>
		      <a @click="tabIndex(4, '/product')" :class="keyIndex == 4 ? 'active' : ''">主营产品</a>
		      <a @click="tabIndex(5, '/bidding')" :class="keyIndex == 5 ? 'active' : ''">招标信息</a>
		      <a @click="tabIndex(6, '/partner')" :class="keyIndex == 6 ? 'active' : ''">合作伙伴</a>
		      <a @click="tabIndex(7, '/news')" :class="keyIndex == 7 ? 'active' : ''">新闻资讯</a>
		      <a @click="tabIndex(8, '/contact')" :class="keyIndex == 8 ? 'active' : ''">联系我们</a>
		    </div>
		    <div class="dl-an clearfix" v-if="isLogin">
		      <a @click="toPage('/login')">
		        <img src="../../assets/images/ico02.png" />
		        <span>登录</span>
		      </a>
		      <a @click="toPage('/register')">
		        <img src="../../assets/images/ico03.png" />
		        <span>注册</span>
		      </a>
		    </div>
		  </div>
		</div>
		
		<div class="top_box">
			<div class="top">
				<div class="top_left">
					个人中心
				</div>
				<div class="top_right">
					您当前所在位置：<a><router-link  to="/home">首页</router-link></a>  <i>></i>  <span>个人中心</span>
				</div>
			</div>
		</div>
		<div class="center_box">
			<div class="center_left">
				<div class="left_first">
					个人中心
				</div>
				<div class="left_item"  @click="openPage('main')">
					<img src="../../assets/icon/m_icon1.png">
					基本信息
				</div>
				<div class="left_item" :style="active" @click="openPage('main_money')">
					<img src="../../assets/icon/m_icon2.png">
					保证金余额
				</div>
				<div class="left_item" @click="openPage('main_record')">
					<img style="height: 20px ;" src="../../assets/icon/m_icon3.png">
					竞拍记录
				</div>
				
				<div class="left_item" @click="openPage('main_news')">
					<img  style="height: 20px ;" src="../../assets/icon/m_icon4.png">
					消息提醒
					<div class="red" v-if="isRed"></div>
				</div>
				<div class="left_item" @click="quit">
					<img src="../../assets/icon/m_icon5.png">
					退出登录
				</div>
			</div>
			<div class="center_right">
				<div class="center_right_top">
					<div class="line"></div>
					保证金余额
				</div>
				<div class="center_right_bottom">
					<div class="center_right_money">
						<div class="flex align-center justify-around" style="margin: 0 auto;width: 60%;">
							<div class="flex flex-direction align-center">
								<div class="flex align-center">
									<img src="../../assets/icon/m_icon7.png"></img>
									保证金余额总数
								</div>
								<div class="money">
									<span>￥</span>
									<span class="span">{{balance}}</span>
									
								</div>
							</div>
							<div class="flex align-center">
							  <div class="btn" @click="showCz = true">
								立即充值
							  </div>
							  <div class="btn" style="background-color: #bc8747 !important;" @click="showTx = true">
								立即提现
							  </div>
							</div>
						</div>
					</div>
					<div class="" style="min-height: 400px;background-color: #fff;">
						<div class="center_right_list">
							<div class="title">
								余额记录
							</div>
							<div class="list_title">
								<div class="" style="flex: 2;">
									余额标题
								</div>
								<div class="" style="flex: 1;">
									变动金额（元）
								</div>
								<div class="" style="flex: 1;">
									当前余额（元）
								</div>
								<div class="" style="flex: 1;">
									时间
								</div>
								<div class="" style="flex: 1;">
									状态
								</div>
							</div>
							<div class="list_box">
								<div class="list_item" v-for="(item,index) in list" :key="index">
								
									<!-- <div class="list_items" style="flex: 2;" v-if="item.status == 2">
										{{item.reson}}
									</div> -->
									<div class="list_items" style="flex: 2;">
										{{item.remark}} {{ item.reson ? ';' : ''}} {{ item.reson || ''}}
									</div>
									<div class="list_items" style="flex: 1;">
										{{item.money}}
									</div>
									<div class="list_items" style="flex: 1;">
										{{item.balance}}
									</div>
									<div class="list_items" style="flex: 1;">
										{{item.create_time_txt}}
									</div>
									<div class="list_items" style="flex: 1;">
										{{item.status_txt}}
									</div>
									
								</div>
							</div>
						</div>
						<div class="elPage" style="margin-bottom: 20px;margin-top: 0px;">
						 <el-pagination
						   background
						   :page-size="5"
						   @current-change="change"
						   @prev-click="prev()"
						   @next-click="next()"
						   layout="prev, pager, next"
						   :total="this.count">
						 </el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	
	<!-- :before-close="handleClose" -->
		<el-dialog
		  :visible.sync="showCz"
		  width="25%">
			<div class="pop_box">
			<div class="pop_image_box">
				<img src="../../assets/icon/m_icon10.png"></img>
				用户充值
			</div>
			  <div class="input_box">
				  <el-input placeholder="请输入充值金额"  v-model="money" >
							<template slot="append">元</template>
				  </el-input>
				  </div>
				<div class="pop_tip" style="margin-bottom: 20px;">
					提醒：将充值金缴纳到以下银行账户，进行审核
				</div>
				<div class="pop_address_box">
					<div class="pop_address">
						{{bank.bank_company_name}}
					</div>
					<div class="pop_address_item">
						{{bank.bank_name}}
					</div>
					<div class="pop_address_item" >
						{{bank.bank_card}}
					</div>
				</div>
				<el-upload
				  action="https://baijihongan.com/api/v1/upload"
				  list-type="picture-card"
				   :class="{disUoloadSty:noneBtnDealImg}"
				  ref="mYupload"
				   name="imgFile"
				   :on-exceed="handleExceed"
				   :on-change="imgChange"
				   :limit='imageLimit'
				   :on-success="onSuccess"
				  :on-preview="handlePictureCardPreview"
				  :on-remove="handleRemove"
				  :auto-upload="true"
				  :file-list='fileList'
				  :disabled="disabled">
				  <i class="el-icon-plus"></i>
				</el-upload>
				<el-dialog :visible.sync="dialogVisible">
				  <img width="100%" :src="dialogImageUrl" alt="">
				</el-dialog>
				<div class="pop_btn" style="margin-bottom: 0px;" @click="checkMoney()">
				确认提交
				</div>
			</div>
		</el-dialog>
		<el-dialog
			custom-class="dialog"
		  :visible.sync="showTx"
		  width="25%">
			<div class="pop_box">
			<div class="pop_image_box" style="margin-bottom: 10px;">
				<img src="../../assets/icon/m_icon11.png"></img>
				用户提现
			</div>
				<div class="input_box">
				  <el-input placeholder="请输入提现金额" v-model="cash_money" >
							<template slot="append">元</template>
				  </el-input>
				 </div>
				<div class="input_box">
				  <el-input placeholder="开户行名称" v-model="bank_name" >
						
				  </el-input>
				 </div>
				 <div class="input_box">
				   <el-input placeholder="开户姓名" v-model="name" >
				   </el-input>
				  </div>
				 <div class="input_box">
				   <el-input placeholder="银行卡号" v-model="card_no" >
				   </el-input>
				  </div>
				  <div class="input_box">
				    <el-input placeholder="手机号" maxlength="11" :disabled="true" v-model="mobile" >
				    </el-input>
				   </div>
				   <div style="display: flex;align-items: center; margin-bottom: 0px;">
					   <div class="input_box" style="margin-right: 20px;margin-bottom: 0px;">
					     <el-input placeholder="验证码" v-model="yzm" >
					     </el-input>
					    </div>
						<el-button @click="sendYanzheng" type="primary">{{send}}</el-button>
				   </div>
				 
				<div class="pop_btn" @click="chenkCach()">
					申请提现
				</div>
				<div class="pop_tip" style="width: 100%;">
					提醒：请确认提现信息，提交后等待审核
				</div>
			</div>
		</el-dialog>
		
		
		
		<div class="footer">
		  <div class="wrapper">
		    <div class="f-nav">
		      <a @click="tabIndex(1, '/home')">首页</a>
		      <a @click="tabIndex(2, '/about')">关于我们</a>
		      <a @click="tabIndex(3, '/honor')">资质荣誉</a>
		      <a @click="tabIndex(4, '/product')">主营产品</a>
		      <a @click="tabIndex(5, '/bidding')">招标信息</a>
		      <a @click="tabIndex(6, '/partner')">合作伙伴</a>
		      <a @click="tabIndex(7, '/news')">新闻资讯</a>
		      <a @click="tabIndex(8, '/contact')">联系我们</a>
		    </div>
		
		    <div class="f-box flexbox">
		      <img src="../../assets/images/logo_foot.png" alt="佰吉宏安国际能源有限公司" class="logo_foot" />
		      <div class="f-center flexbox33 flexwarp" style="text-align: left;">
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico05.png" />
		          <p>联系电话：{{ footerMassage.mobile }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico06.png" />
		          <p>邮政编码：{{ footerMassage.postal }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico07.png" />
		          <p>访问量：{{ footerMassage.pageviews }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico08.png" />
		          <p>电子邮箱：{{ footerMassage.email }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico09.png" />
		          <p>公司地址：{{ footerMassage.address }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico10.png" />
		          <p>交易量：{{ footerMassage.trading_volume }}</p>
		        </div>
		      </div>
		      <div class="qrcode">
		        <img :src="footerMassage.image_id5_url" alt="" />
		        <p>扫一扫了解更多</p>
		      </div>
		    </div>
		    <div class="copyright">
		      Copyright 2021 ·版权所有 佰吉宏安国际能源有限公司
		      <a href="https://beian.miit.gov.cn" target="_blank">{{ footerMassage.site_icp }}&nbsp;{{ footerMassage.site_wabah }}</a>
		      <br />
		      建议使用1920*1080以上的屏幕分辨率和8.0以上版本的浏览器来访问本站，本站不支持IE浏览器
		    </div>
		  </div>
		</div>
    </div>
</template>

<script>
	import Utils from '../../utils/utils.js';
export default {
    name: 'main_money',
    data() {
        return {
			input2:'',
			money:'',
		   active:'background-color: #e6e6e6;',
		   showCz:false,
		   showTx:false,
		    isRed:false,
			list:[],
			page:1,
			count:0,
			balance:'',
			bank:'',
			dialogImageUrl: '',
			dialogVisible: false,
			disabled: false,
			imageLimit:1,
			imageId:'',
			fileList:[],
			cash_money:'',
			bank_name:'',
			name:'',
			card_no:'',
			mobile:"",
			send:'发送验证码',
			time: 60,
			yzm:'',
			noneBtnDealImg:false,
			
			keyIndex:0,
			isLogin: true,
			footerMassage:'',
		};
    },
    mounted() {
		this.getList()
		this.getInfo()
		this.getRed()
		this.getBank()
		
		this.site_info()
    },
    methods: {
		async getInfo() {
			var _this = this
		    let { status, message, data } = await _this.$ajax('getInfo', {
		        userToken: _this.$getStorage('userToken'),
		    });
		    if (status === _this.SUCCESS_CODE) {
				_this.mobile = data.mobile
				
		    } else {
		        _this.$message.error(message);
		    }
		},
		// 发送验证码
		sendYanzheng(){
		    var _this = this;
		    if (!/^1[2-9]\d{9}$/.test(_this.mobile)) {
				_this.$message({
				  message: '请输入有效的手机号',
				  type: 'warning'
				});
		        return false;
		    }
		    if (_this.send != '发送验证码') return;
			_this.getVerify()
		},
		async getVerify() {
			var _this = this;
		   let { status, message, data } = await _this.$ajax('verify', {
		   	mobile:_this.mobile,
			type:5
		   });
		   if (status == _this.SUCCESS_CODE) {
			   _this.$message({
					message: '发送成功！请注意查收',
					type: 'success'
			   });
				_this.countDown()
		   } else {
		        _this.$message.error(message);
		   }
		},
		// 验证码倒计时
		countDown() { //验证码倒计时
		    var _this = this;
		    switch (_this.send) {
		        case '发送验证码':
		            _this.send = _this.time + 's';
		            var timer = setInterval(function () {
		                if (--_this.time <= 0) {
		                    clearInterval(timer);
		                    _this.send = '发送验证码';
		                    _this.time = 60;
		                } else {
		                    _this.send = _this.time + 's';
		                }
		            }, 1000);
		            break;
		    }
		},
		quit() {
			this.$confirm('您确定退出吗?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
			  this.$message({
				type: 'success',
				message: '退出成功!'
			  });
			  window.sessionStorage.clear()
			  this.$router.push({
			      path: "/home"
			  });
			  window.location.reload();
			}).catch(() => {
			          
			});
		  },
		chenkCach(){
			var _this = this
			if(_this.cash_money == 0){
				_this.$message({
				  message: '金额不能为0',
				  type: 'warning'
				});
				return
			}
			if(_this.cash_money == ''){
				_this.$message({
				  message: '请输入金额',
				  type: 'warning'
				});
				return
			}
			if(isNaN(_this.cash_money)){
			   _this.$message({
			     message: '请输入正确的金额',
			     type: 'warning'
			   });
			   return
			}
			if(_this.cash_money%1 !== 0){
				_this.$message({
				  message: '请输入整数金额',
				  type: 'warning'
				});
				return
			}
			if(_this.bank_name == ''){
				_this.$message({
				  message: '请输入开户行名称',
				  type: 'warning'
				});
				return
			}
			if(_this.name == ''){
				_this.$message({
				  message: '请输入开户人姓名',
				  type: 'warning'
				});
				return
			}
			if(_this.card_no == ''){
				_this.$message({
				  message: '请输入银行卡号',
				  type: 'warning'
				});
				return
			}
			if(_this.mobile == ''){
				_this.$message({
				  message: '请输入开户行预留手机号',
				  type: 'warning'
				});
				return
			}
			if (!/^1[2-9]\d{9}$/.test(_this.mobile)) {
				_this.$message({
				  message: '请输入有效的手机号',
				  type: 'warning'
				});
			    return false;
			}
			if(_this.yzm == ''){
				_this.$message({
				  message: '请输入验证码',
				  type: 'warning'
				});
				return
			}
			this.$confirm('您确定申请提现吗?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
			_this.sendCash()
			 
			}).catch(() => {
			          
			});
		},
		async sendCash() {
			var _this = this
		    let { status, message, data } = await this.$ajax('cash', {
				userToken: this.$getStorage('userToken'),
				money:this.cash_money,
				name:this.name,
				bank:this.bank_name,		
				card_no:this.card_no,
				mobile:this.mobile,
				code:this.yzm
		   });
		    if (status == this.SUCCESS_CODE) {
					_this.$message({
						type: 'success',
						message: '申请成功!请耐心等待审核'
					});
					_this.cash_money = ''
					_this.name= ''
					_this.bank_name= ''		
					_this.card_no= ''
					// _this.mobile= ''
					_this.yzm = ''
					_this.getList()
					_this.showTx = false
		    } else {
		        this.$message(message);
		    }
		},
		handleExceed(){
			_this.$message({
			  message: '限传一张，请先删除列表中的图片',
			  type: 'warning'
			});
			return
		},
		onSuccess(e){
			console.log(e)
			this.imageId = e.data.id
		},
		imgChange(file, fileList){
		  this.noneBtnDealImg = fileList.length >= 1
		},
		 handleRemove(file) {
			this.imageId = ''
			this.dialogImageUrl = ''
			this.noneBtnDealImg = false
		  },
		 handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		 },
		checkMoney(){
			var _this = this
			if(_this.money == 0){
				_this.$message({
				  message: '金额不能为0',
				  type: 'warning'
				});
				return
			}
			if(_this.money == ''){
				_this.$message({
				  message: '请输入金额',
				  type: 'warning'
				});
				return
			}
			if(isNaN(_this.money)){
			   _this.$message({
			     message: '请输入正确的金额',
			     type: 'warning'
			   });
			   return
			}
			if(!_this.money%1 !==  0){
				_this.$message({
				  message: '请输入整数金额',
				  type: 'warning'
				});
				return
			}
			if(this.imageId == ''){
				_this.$message({
				  message: '请上传凭证',
				  type: 'warning'
				});
				return
			}
			this.sendMoney()
		},
		async sendMoney() {
			var _this = this
		    let { status, message, data } = await this.$ajax('recharge', {
				userToken: this.$getStorage('userToken'),
				attaches_id:this.imageId,
				money:this.money
		   });
		    if (status == this.SUCCESS_CODE) {
					_this.$message({
					  message: '上传成功！请耐心等待审核',
					  type: 'success'
					});
					_this.$refs['mYupload'].clearFiles();
					_this.money = ''
					_this.imageId = ''
					_this.showCz = false
					_this.noneBtnDealImg = false
		    } else {
		        this.$message(message);
		    }
		},
		async getBank() {
			var _this = this
		    let { status, message, data } = await this.$ajax('site_info', {
		    });
		    if (status == this.SUCCESS_CODE) {
				this.bank = data
		    } else {
		        this.$message(message);
		    }
		},
		async getRed() {
				  var _this = this
		    let { status, message, data } = await this.$ajax('no_read_information', {
					userToken: this.$getStorage('userToken'),
		    });
		    if (status == this.SUCCESS_CODE) {
				  Utils.$emit('getRed','msg');
					if(data == 0){
						_this.isRed = false
					}else{
						_this.isRed = true
					}
		    } else {
		        this.$message(message);
		    }
		},
		openPage(str){
			this.$router.push({
				path: str,
				// query: {  }
			});
		}, 
       change(e){
       	this.page = e
       	this.getList()
       },
       prev(e){
       	this.page = this.page - 1
       	this.getList()
       },
       next(e){
       	this.page = this.page + 1
       	this.getList()
       },
         async getList() {
             let { status, message, data } = await this.$ajax('balance_list', {
       		page:this.page,
       		limit:5,
       		userToken: this.$getStorage('userToken'),
             });
             if (status == this.SUCCESS_CODE) {
				 this.balance = data.balance
					this.count = data.count
					this.list = data.list
             } else {
                 this.$message(message);
             }
         },
       //底部导航信息
       async site_info(idnex) {
         this.timeIndex = idnex;
         if (this.$getStorage('userToken')) {
           this.isLogin = false;
         } else {
           this.isLogin = true;
         }
         let { status, message, data } = await this.$ajax('site_info', {});
         if (status == this.SUCCESS_CODE) {
           this.footerMassage = data;
         } else {
           this.$message(message);
         }
       },
       yanzheng(str) {
         var _this = this;
         if (this.$getStorage('userToken')) {
           _this.toPage(str);
         } else {
           _this.$message({
             message: '请先登录',
             type: 'warning'
           });
           _this.toPage('/login');
         }
       },
       toPage(pathName, title) {
         this.$router.push({
           path: pathName,
           query: { pageTitle: title }
         });
       },
       tabIndex(index, str) {
       
         this.$router.push({
           path: str
         });
       },
    }
};
</script>

<style scoped>
	/* .center_left a:hover{
		background-color: #F5F5F5;
	} */
	.conten{
		background-color: #F5F5F5;
	}
	.top_box{
		width: 100%;
		height:55px;
		background-color: #fff;
		display: flex;
		align-items: center;
	}
	.top{
		width:1320px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0 auto;
	}
	.top_left{
		font-size: 19px;
		font-weight: bold;
		margin-left: 10px;
	}
	.left_first{
		padding: 12px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		background-color: #8a0d02;
	}
	.red{
		position: absolute;
		background-color: #ff1400;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		right: 38px;
		top: 12px;
		z-index: 80;
	}
	.left_item{
		background-color: #fff;
		padding: 14px 25px;
		display: flex;
		align-items: center;
		font-size: 13px;
		font-weight: bold;
		border-bottom: 1px solid #f3f3f3;
		position: relative;
	}
	.left_item img{
		width: 18px;
		height: 18px;
		display: block;
		margin-right: 10px;
	}
	.top_right{
		font-size: 10px;
		display: flex;
		align-items: center;
		color:#666666;
		margin-right: 10px;
	}
	.top_right a{
		margin-right:5px;
	}
	.top_right span{
		margin-left: 5px;
		font-weight: 600;
		color: #000 !important;
	}
	.center_box{
		width: 1300px;
		display: flex;
		justify-content: space-between;
		margin: 20px auto;
	}
	.center_left{
		background-color: #fff;
		width:150px;
		margin-right: 10px;
		padding-bottom: 200px;
	}
	.center_right{
		flex: 1;
	}
	.center_right_top{
		display: flex;
		align-items: center;
		padding: 12px;
		background-color: #fff;
		margin-bottom: 10px;
		font-size: 12px;
		font-weight: bold;
	}
	.center_right_top div{
		width: 3px;
		height: 14px;
		background-color: #8a0d02;
		margin-right: 8px;
	}
	.center_right_bottom{
		min-height: 500px;
		display: flex;
		flex-direction: column;
	}
	.center_right_money{
		height: 120px;
		display: flex;
		align-items: center;
		background-color: #fff;
		margin-bottom: 10px;
		
	}
	.center_right_money img{
		width:17px;
		height: 19px;
		margin-right: 5px;
	}
	.left_item:hover{
		background-color: #F5F5F5 !important; 
	}
	.btn{
		width:130px;
		margin-left:20px;
		height:45px;
		line-height:45px; 
		font-weight: bold;
		text-align:center;
		color:#fff;
		font-size:14px;
		background-color:#8a0d02;
	}
	.money{
		color:#8a0d02 ;
		font-weight: bold;
		font-size: 18px;
	}
	.money .span{
		font-size: 30px;
	}
	.center_right_list{
		flex: 1;
		display: flex;
		flex-direction: column;
		width: 100%;
		background-color: #fff;
		padding: 20px 40px;
	}
	.title{
		font-weight: bold;
		font-size: 16px;
		margin-bottom: 20px;
		width: 100%;
		text-align: left;
	}
	.list_title{
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #f5f5f5;
		padding: 10px 0px;
		font-size: 14px;
	}
	.list_box{
		/* height: 300px; */
	}
	.list_item{
		width: 100%;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #e5e5e5;
		height: 60px;
	}
	.list_items{
		text-align: center;
	}
	.elPage{
		width: 100%;
		margin-top: 20px;
	} 
	
	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #8a0d02 ;
	} 
	 /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover{
		color: #8a0d02;
	}
	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
		color: #fff ;
	} 
	
/* 	/deep/.el-pagination.is-background .el-pager li:(.disabled):hover{
		color: #fff;
	}
	 */
	/deep/.input_box .el-input__inner, .el-input-group__prepend{
		padding: 0px 15px;
	}
	/deep/.input_box .el-input-group__append{
		background-color: #FFF !important;
		border: none !important;
		color: #000;
	}
	.pop_box{
		display: flex;
		flex-direction: column;
		/* align-items: center; */
	}
	.pop_image_box{
		display: flex;
		align-items: center;
		flex-direction: column;
		align-items: center;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 30px;
		color: #000;
	}
	.pop_image_box img{
		display: block;
		margin-bottom: 10px;
		width: 60px;
		height: 60px;
	}
	.input_box{
		margin-bottom: 10px;
		width: 100%;
		border: 1px solid #dddddd; 
	}
	.pop_btn{
		width:100%;
		height:45px;
		line-height:45px; 
		font-weight: bold;
		text-align:center;
		border-radius: 4px;
		color:#fff;
		font-size:14px;
		margin: 15px 0px;
		background-color:#af2f24;
	}
	
	/deep/ .el-dialog__body{
		padding: 20px !important;
	}
	/deep/ .el-dialog__header{
		padding: 0px !important;
	}
	.pop_tip{
		font-size:8px;
		padding: 2px 7px;
		background-color: #ffffe5;
		border: 1px solid #ffcc7f;
		width: 65%;
		margin-bottom: 30px;
	}
	.pop_address_box{
		width: 70%;
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		margin-bottom: 10px;
		border: 1px solid #b07b40;
	}
	.pop_address{
		padding: 3px;
		font-size: 15px;
		font-weight: bold;
		background-color: #b07b40;
		color: #fff;
		margin-bottom: 7px;
	}
	.pop_address_item{
		font-size: 15px;
		text-align: center;
		margin-bottom: 7px;
		color: #000;
	}
	/deep/ .dialog .input_box .el-input-group__append{
		background-color: #FFF !important;
		border: none !important;
		color: red;
	}
	.disUoloadSty .el-upload--picture-card{
	  display:none    /* 上传按钮隐藏 */
	}
</style>



// WEBPACK FOOTER //
// src/views/main/main_money.vue